module.exports = __webpack_public_path__ + "img/bg.5399c13f.png";